import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/cekr.svg'


const _withScopeId = n => (_pushScopeId("data-v-4e2cd2f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_3 = { class: "wp1200" }
const _hoisted_4 = { class: "flex full" }
const _hoisted_5 = { class: "col2_3 flex" }
const _hoisted_6 = { class: "col1_3" }
const _hoisted_7 = { class: "userTab" }
const _hoisted_8 = { class: "data" }
const _hoisted_9 = { class: "myTown" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "sideMenu" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_user" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["tabindex"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_message" }, null, -1))
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  href: "#",
  class: "disabled"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_info" }, null, -1))
const _hoisted_21 = ["tabindex"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationList = _resolveComponent("NavigationList")!
  const _component_AvatarCustom = _resolveComponent("AvatarCustom")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SignUpRegistration = _resolveComponent("SignUpRegistration")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["topRight", { light: _ctx.$store.getters['user/isLoggedIn'] === false }])
    }, null, 2),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_NavigationList, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.dispatch('navigation/setShow', false)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.$store.getters['user/isLoggedIn'] && _ctx.user !== null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_AvatarCustom, {
                    src: _ctx.$store.getters['user/userImage'],
                    class: "large responsive"
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("navigation.my_supercity")), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name), 1)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      tabindex: _ctx.showNavigation ? 0 : -1,
                      to: { name: 'MySuperCity' },
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("navigation.my_supercity")), 1)
                      ]),
                      _: 1
                    }, 8, ["tabindex"])
                  ]),
                  (_ctx.isCekrEnabled)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                        _createElementVNode("a", {
                          tabindex: _ctx.showNavigation ? 0 : -1,
                          href: "https://cekr.kranj.si",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                        }, [
                          _hoisted_15,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("navigation.cekr")), 1)
                        ], 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$store.getters['user/verificationLevel'] >= 1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          tabindex: _ctx.showNavigation ? 0 : -1,
                          to: { name: 'FeedbackDashboard' },
                          onClick: _ctx.navigateToTellCity
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("navigation.tell_city")), 1)
                          ]),
                          _: 1
                        }, 8, ["tabindex", "onClick"])
                      ]))
                    : (_openBlock(), _createElementBlock("li", _hoisted_18, [
                        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("navigation.tell_city")), 1)
                        ])), [
                          [
                            _directive_tooltip,
                            _ctx.tellCityTooltip,
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]))
                ]),
                _createElementVNode("a", {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout())),
                  class: "logOut"
                }, _toDisplayString(_ctx.$t("navigation.logout")), 9, _hoisted_21)
              ], 64))
            : (_openBlock(), _createBlock(_component_SignUpRegistration, { key: 1 }))
        ])
      ])
    ])
  ]))
}